export enum CandidateScoreRating {
    Hottest = 1,
    Hotter = 2,
    Hot = 3,
    Marketing = 4
}

export const determineCandidateScoreRatingText = (rating: CandidateScoreRating) => {
    let text = "Low";
    switch (rating) {
        case CandidateScoreRating.Hottest:
            text = 'Very High';
            break;
        case CandidateScoreRating.Hotter:
            text = 'High';
            break;
        case CandidateScoreRating.Hot:
            text = 'Standard';
            break;
    }
    return text;
}
